import { Trace } from "../../../telemetry/Trace";
import { dashboard } from "../../../telemetry/TraceLogging";
import { getIsWindowVisible } from "../../externalApi/WindowApi";
import widgetApiVersion from "../apis/api.interfaces";
export class WidgetFrameAdapter {
    constructor(widgetInstance) {
        this.widgetInstance = widgetInstance;
    }
    async onVisibleStateChanged(isVisible) {
        let isWindowVisible = await getIsWindowVisible();
        Trace.logEvent(dashboard, "WidgetVisibility", 1 /* information */, {
            indexedDBInstanceId: this.widgetInstance.instanceId,
            widgetVisible: isVisible,
            widgetDefinitionId: this.widgetInstance.widgetDefinitionId,
            widgetInstanceId: this.widgetInstance.widgetId,
            windowVisible: isWindowVisible,
        });
        const visibilityApi = this.widgetInstance.tryGetApi("visibility", 1, widgetApiVersion);
        if (visibilityApi) {
            // Only notify onVisible if the window is also visible
            // Notify onHidden even if the window is currently not visible
            if (isWindowVisible && isVisible) {
                visibilityApi.onVisible();
            }
            else if (!isVisible) {
                visibilityApi.onHidden();
            }
        }
    }
}
